/**
 * Non-error console output — dev server only (stripped from production bundles via dead-code elimination).
 */

function isDevBuild() {
  return typeof import.meta !== "undefined" && import.meta.env && import.meta.env.DEV;
}

/** @param {...unknown} args */
export function devLog(...args) {
  if (isDevBuild()) console.log(...args);
}

/** @param {...unknown} args */
export function devDebug(...args) {
  if (isDevBuild()) console.debug(...args);
}

/** @param {...unknown} args */
export function devInfo(...args) {
  if (isDevBuild()) console.info(...args);
}
